module.exports = __webpack_public_path__ + "img/guilin.e836eecd.png";